<template>
  <div class="signin-case">
    <div class="title" @click="openDialog">
      <div class="title-text">签到情况</div>
      <div class="title-nexticon iconfont icon-icon_more"></div>
    </div>
    <div class="types">
      <div class="type actual">
        <p class="type-name">实到人数</p>
        <p class="type-num">{{ courseList.realNum || 0 }}</p>
      </div>
      <div class="type shoud">
        <p class="type-name">应到人数</p>
        <p class="type-num">{{ courseList.shouldNum || 0 }}</p>
      </div>
    </div>
    <div class="list">
      <div
        class="list-item"
        v-for="(item, index) in courseList.signMessageList"
        :key="index"
      >
        <van-image class="list-headerimg" lazy-load :src="item.photo |imgFormat">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
          <template v-slot:error>
            <img class="list-errorimg" :src="defaultImg" style="width: 100%; height: 100%"/>
          </template>
        </van-image>
        <div class="name">{{ item.name || "" }}</div>
        <div class="time">{{ dsf.date.format(item.signInTime, "hh:ii:ss") }}</div>
      </div>
    </div>
    <van-dialog
      v-model="DetailsDialog"
      width="80%"
      title="点击任意处关闭"
      close-on-click-overlay
      :show-confirm-button="false"
    >
      <SigninDetails :stuList="stuList" :classNameSet="classNameSet" />
    </van-dialog>
  </div>
</template>

<script>
import SigninDetails from "./SigninDetails.vue";
// 签到情况
export default {
  components: {
    SigninDetails,
  },
  data() {
    return {
      DetailsDialog: false, //签到详情弹窗
      stuList: {}, //所有学员的所有考勤情况
      courseList: {}, //课程详情里面的签到情况
      defaultImg: dsf.config.setting_public_user_default_header,
    };
  },
  props: {
    //当前班次
    classNameSet: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getSignCondition();
  },
  methods: {
    openDialog() {
      this.getAllStudentSign();
    },
    //获取所有学员的所有考勤情况
    getAllStudentSign() {
      let _this = this;
      this.$http
        .get(
          "teas/screen/getSignInInfo",
          {
            id: this.$route.query.id || "", //事项id
            type: this.$route.query.type || "",  //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式 
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            _this.stuList = data;
            _this.DetailsDialog = true;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    //获取课程详情里面的签到情况
    getSignCondition() {
      this.$http
        .get(
          "teas/screen/getSignCondition",
          {
            id: this.$route.query.id || "", //事项id
            type: this.$route.query.type || "",  //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式 
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            this.courseList = data;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
  },
};
</script>